import { forexBasicsLearningPath } from '@/mocks/forexBasics';
import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function BasicsLearningPath() {
  return (
    <section className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="เส้นทางการเรียนรู้"
          title="ควรเริ่มเรียน Forex จากตรงไหน"
          subtitle="เรียงลำดับ 4 ขั้นตอนให้มือใหม่เข้าใจง่าย เริ่มจากทำความรู้จักตลาด ไปจนถึงเข้าใจความเสี่ยงก่อนเทรดจริง"
        />

        <div className="relative mt-12">
          <div className="absolute left-6 top-2 h-[calc(100%-1rem)] w-px bg-background-300 lg:hidden" />
          <div className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-background-300 lg:block" />
          <div className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px origin-left animate-draw-line bg-primary-300 lg:block" />

          <ol className="grid grid-cols-1 gap-10 lg:grid-cols-4 lg:gap-6">
            {forexBasicsLearningPath.map((stage, index) => (
              <ScrollReveal as="li" key={stage.no} delay={index * 90}>
                <a
                  href={stage.link}
                  className="group flex gap-4 rounded-lg transition-transform duration-300 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 lg:flex-col"
                >
                  <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-background-50 font-num text-lg font-semibold text-primary-700 transition-all duration-300 ease-out group-hover:-translate-y-0.5 group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 group-hover:ring-4 group-hover:ring-primary-100">
                    {stage.no}
                  </span>

                  <div className="lg:mt-6">
                    <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-primary-600">
                      <i className={`${stage.icon} text-base`} />
                      ขั้นตอนที่ {index + 1}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                      {stage.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{stage.desc}</p>
                  </div>
                </a>
              </ScrollReveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}